// TODO Fix everything with eslint-disable-next-line @typescript-eslint/no-redeclare
import * as types from 'types';
import { ICore } from '../../../types';

export type CoreState = ICore;

export enum CoreActionTypes {
  UPDATE_LEGAL_ADVISE_DISCLAIMER = '@@student/core/UPDATE_LEGAL_ADVISE_DISCLAIMER',
  UPDATE_INFO_PROCESSING = '@@student/core/UPDATE_INFO_PROCESSING'
}

export const Status = types.CoreStatusExtended;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type Status = types.CoreStatusExtended;

export const VisaStatus = types.VisaStatus;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type VisaStatus = types.VisaStatus;
